// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2MRWn","productName":"Table_productName__25Gmm"};